module.exports = __webpack_public_path__ + "img/shortSkirt.1767e57d.png";